module.exports = __webpack_public_path__ + "img/iku nagae_sc2.14a9fa9c.png";